// action - account reducer firebase
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const FIREBASE_STATE_CHANGED = "FIREBASE_STATE_CHANGED";

// action admin - Login in MERN
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const ADMIN_LOADED = "ADMIN_LOADED";
export const AUTH_FAIL = "AUTH_FAIL";
export const SET_ALERT = "SET_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const DELETE_ALL_ALERT = "DELETE_ALL_ALERT";
export const LOGIN_SUB_ADMIN_SUCCESS = "LOGIN_SUB_ADMIN_SUCCESS";

export const GET_ALL_SHOP_DATA = "GET_ALL_SHOP_DATA"
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ACTIVE_TABLE_DATA = "GET_ACTIVE_TABLE_DATA";

export const GET_RECORDS = "GET_RECORDS";
export const GET_USER_FOR_QR="GET_USER_FOR_QR"